import React from 'react';
import { clsx } from 'clsx';

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
}

export function Table({ children, className, ...props }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table 
        className={clsx("min-w-full divide-y divide-gray-200", className)} 
        {...props}
      >
        {children}
      </table>
    </div>
  );
} 